const index = function () {
    return window.axios.get('/api/service-reminder-types');
};

const create = function (data) {
    return window.axios.post('/api/service-reminder-types', data);
};

const update = function (data) {
    return window.axios.put('/api/service-reminder-types/' + data.id, data);
};

const deleteType = function (id) {
    return window.axios.delete('/api/service-reminder-types/' + id);
};

const save = function (data) {
    if (data.id) {
        return update(data);
    }

    return create(data);
};

const toOptions = function (types) {
    return types.map(function (type) {
        return {
            value: type.slug,
            label: type.name,
        };
    });
};

export default {
    index,
    create,
    update,
    delete: deleteType,
    save,
    toOptions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/ServiceReminderTypeService.js